<template>
    <div>
        <slot 
            :formCrear="formCrear"
            :comoUnSelect="comoUnSelect"
            :comoUnSelectEscuela="comoUnSelectEscuela">
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';
import selectpicker from "bootstrap-select";

export default {
    data() { return {
        formCrear: {
            curp: '',
            apellido_paterno: '',
            apellido_materno: '',
            nombres: '',
            fecha_nacimiento: '',
        },
        curpRespaldo: '',
    }},
    mounted() {
        const vm = this;
        const form = $('#crearProspectoFormId');
        const ap_paterno = $('#ap_paterno_crear');
        const ap_materno = $('#ap_materno_crear');
        const nombres = $('#nombres_crear');
        const fecha = $('#fecha_crear');
        const curp = $('#curp');
        const warning_alert = $('#warning_alert');
        const curp_warning = $('#curp_warning');
        const como_se_entero_id_editar = $('#como_se_entero_id_editar');
        const escuela_procedencia_id_editar = $('#escuela_procedencia_id_editar');
        const familiar_parentesco = $('#familiar_parentesco');

        form.submit(function(event) {
            event.preventDefault();
            vm.crearProspecto();
        });

        ap_paterno.focusout(function() {
            vm.generarCurp();
        });
        ap_materno.focusout(function() {
            vm.generarCurp();
        });
        nombres.focusout(function() {
            vm.generarCurp();
        });
        fecha.focusout(function() {
            vm.generarCurp();
        });

        curp.keyup(function() {
            if(curp.val() != '') {
                warning_alert.css('visibility', 'hidden');
                curp_warning.prop('checked', true);
            } else {
                warning_alert.css('visibility', 'visible');
                curp_warning.prop('checked', false);
            }
        });

        setTimeout(() => {
            $('#institucion_id_index').val(null);
        }, 500);

        $('#comoUnSelectId').click(function() {
            como_se_entero_id_editar.selectpicker('val', null);
            como_se_entero_id_editar.selectpicker('refresh');
        });

        $('#comoUnSelectIdEditar').click(function() {
            escuela_procedencia_id_editar.selectpicker('val', null);
            escuela_procedencia_id_editar.selectpicker('refresh');
        });

        $('#editarRegistro').on('show.bs.modal', function (e) {
            setTimeout(() => {
                como_se_entero_id_editar.selectpicker('refresh');
                escuela_procedencia_id_editar.selectpicker('refresh');
            }, 1500);
        })

        $('#_crearRegistro').on('show.bs.modal', function (e) {
            setTimeout(() => {
                familiar_parentesco.selectpicker('val', 'padre');
                familiar_parentesco.selectpicker('refresh');
                vm.formCrear.familiar_parentesco = 'padre'
            }, 1500);
        })
    },
    methods: {
        comoUnSelectEscuela() {
            const escuela_procedencia_id = $('#escuela_procedencia_id');
            escuela_procedencia_id.selectpicker('val', null);
            escuela_procedencia_id.selectpicker('refresh');
            this.formCrear.escuela_procedencia_id = null;
        },
        comoUnSelect() {
            const como_se_entero_id_crear = $('#como_se_entero_id_crear');
            como_se_entero_id_crear.selectpicker('val', null);
            como_se_entero_id_crear.selectpicker('refresh');
            this.formCrear.como_se_entero_id = null;
        },
        crearProspecto() {
            const curp_shadow = $('#curp_shadow');
            const warning_alert = $('#warning_alert');
            const curp_warning = $('#curp_warning');

            this.curpRespaldo = this.formCrear.curp;
            this.formCrear.curp = curp_shadow.val() + this.formCrear.curp;
            this.formCrear.hermano_id = $('#buscarFamiliarInputId').val();

            Axios.post('prospectos/store', this.formCrear).then(res => {
                $('#_crearRegistro').modal('hide');

                this.formCrear.curp = '';
                this.formCrear.apellido_paterno = '';
                this.formCrear.apellido_materno = '';
                this.formCrear.nombres = '';
                this.formCrear.fecha_nacimiento = '';
                this.formCrear.familiar_apellido_paterno = '';
                this.formCrear.familiar_apellido_materno = '';
                this.formCrear.familiar_nombres = '';
                this.formCrear.familiar_correo = '';
                this.formCrear.familiar_telefono = '';
                
                curp_shadow.val('');
                warning_alert.css('visibility', 'visible');
                curp_warning.prop('checked', false);

                $('#buscarFamiliarInputId').val('');
                toastr["success"]('Nuevo prospecto agregado', "Éxito");
            }).catch(e => {
                this.formCrear.curp = this.curpRespaldo;
                this.curpRespaldo = '';
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        generarCurp() {
            const curp_shadow = $('#curp_shadow');

            const t_paterno = this.formCrear.apellido_paterno.substr(0, 2).toUpperCase();
            const t_materno = this.formCrear.apellido_materno.substr(0, 1).toUpperCase();
            const t_nombre = this.formCrear.nombres.substr(0, 1).toUpperCase();
            const t_fecha_year = this.formCrear.fecha_nacimiento.substr(2, 2);
            const t_fecha_month = this.formCrear.fecha_nacimiento.substr(5, 2);
            const t_fecha_day = this.formCrear.fecha_nacimiento.substr(8, 2);

            curp_shadow.val(t_paterno + 
                t_materno + 
                t_nombre + 
                t_fecha_year +
                t_fecha_month +
                t_fecha_day
            );
        },
    },
}
</script>